export default __webpack_public_path__ + "static/media/platformDeviceIcon1.858dbc8b.png";